import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';

const BonusMalusItem = ({
  bonusMalusObject,
  categoryId,
  updateBMPoints,
  quantity
}) => {
  const { id, name, value } = bonusMalusObject;

  const updateBonusMalusPoints = (quantity, value) => {
    const scoreObject = {
      quantity: quantity,
      value: value
    };
    updateBMPoints(categoryId, id, scoreObject);
  };

  const handleIncrease = () => {
    if (quantity < 50) {
      const q = quantity + 1;
      updateBonusMalusPoints(q, value);
    }
  };

  const handleDecrease = () => {
    if (quantity > 0) {
      const q = quantity - 1;
      updateBonusMalusPoints(q, -value);
    }
  };

  const handleChange = event => {
    let newQuantity = parseInt(event.target.value, 10);
    if (isNaN(newQuantity)) newQuantity = 0;
    else if (newQuantity > 50) newQuantity = 50;
    else if (newQuantity < 0) newQuantity = -newQuantity;

    const pointsChange = (newQuantity - quantity) * value;
    updateBonusMalusPoints(newQuantity, pointsChange);
  };

  return (
    <>
      <Row className="gx-card mx-0 align-items-center border-top border-200">
        <Col xs={7} className="py-3">
          <div className="d-flex align-items-center">
            <div className="flex-1">
              <h5 className="fs-9">{name}</h5>
            </div>
          </div>
        </Col>
        <Col xs={5} className="py-3">
          <Row className="align-items-center">
            <Col
              md={{ span: 8, order: 0 }}
              xs={{ order: 1 }}
              className="d-flex justify-content-end justify-content-md-center"
            >
              <div>
                <InputGroup size="sm">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="border-300 px-2 btn-in"
                    onClick={handleDecrease}
                  >
                    -
                  </Button>
                  <Form.Control
                    className="text-center px-2 input-spin-none"
                    type="number"
                    min={0}
                    max={50}
                    value={quantity}
                    onChange={handleChange}
                    style={{ width: '50px' }}
                  />
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="border-300 px-2 btn-in"
                    onClick={handleIncrease}
                  >
                    +
                  </Button>
                </InputGroup>
              </div>
            </Col>
            <Col
              md={{ span: 4, order: 1 }}
              xs={{ order: 0 }}
              className="text-end ps-0 mb-2 mb-md-0"
            >
              <span
                className={'fw-bold text-' + (value > 0 ? 'success' : 'danger')}
              >
                {value > 0 ? '+' : ''}
                {value}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

BonusMalusItem.propTypes = {
  bonusMalusObject: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  categoryId: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  updateBMPoints: PropTypes.func.isRequired
};

export default BonusMalusItem;
